module.exports = __webpack_public_path__ + "static/media/ts-logo.14b4c94c.png";